import { AfterViewInit, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { MASKS } from 'ng-brazil';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { TipoArquivo } from 'src/app/models/enum';
import { Marca } from 'src/app/models/marca';
import { ArquivoService } from 'src/app/services/arquivo.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { MarcaService } from 'src/app/services/marca.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { ViaCepService } from 'src/app/services/via-cep.service';

// jquery
declare const $: any;

@Component({
  selector: 'app-cadastrar-marca',
  templateUrl: './cadastrar-marca.component.html',
  styleUrls: ['./cadastrar-marca.component.scss']
})
export class CadastrarMarcaComponent implements OnInit, OnDestroy, AfterViewInit {


  // variáveis
  marca = new Marca();
  editando = false;
  carregando = true;
  public MASKS = MASKS;
  editavel = true;
  pegouFranquia = false;
  public config: PerfectScrollbarConfigInterface = {};

  selectedFile: File;
  nomeArquivoBanco = '';

  constructor(private route: ActivatedRoute, private notificacaoService: NotificacaoService,
    private marcaService: MarcaService, public dialogRef: MatDialogRef<CadastrarMarcaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private arquivoService: ArquivoService,
    private router: Router, private viaCepService: ViaCepService, private utilitarioService:UtilitarioService,
    private globalService: GlobalService, private carregandoService: CarregandoService) { }

  ngOnInit() {
    this.marca = this.data.marca;
    this.nomeArquivoBanco = this.marca.imagem;
  }

  ngAfterViewInit(): void {

    $(document).ready(function () {
      $('input').keypress(function (e) {

        let code = null;
        code = (e.keyCode ? e.keyCode : e.which);
        return (code === 13) ? false : true;

      });

      $('input').keydown(function (e) {
        // Obter o próximo índice do elemento de entrada de texto
        let next_idx = $('input').index(this) + 1;

        // Obter o número de elemento de entrada de texto em um documento html
        let tot_idx = $('body').find('input').length;

        // Entra na tecla no código ASCII
        if (e.keyCode === 13) {
          if (tot_idx === next_idx)
            // Vá para o primeiro elemento de texto
            $('input:eq(0)').focus();
          else
            // Vá para o elemento de entrada de texto seguinte
            $('input:eq(' + next_idx + ')').focus();
        }
      });
    });
  }



  atualizaDadosMarca() {


    this.carregando = false;

    this.carregandoService.esconde('buscaMarca');
  }

  salvar() {
    this.carregandoService.mostra('salvaMarca');

    const dados = new FormData();
    if (this.selectedFile) {
      dados.append('arquivo_consulta', this.selectedFile);
      dados.append('marca[imagem]', this.selectedFile.name);
    } else {
      dados.append('marca[imagem]', this.marca.imagem);
    }

    dados.append('marca[idMarca]', this.marca.idMarca ? this.marca.idMarca.toString() : '0');
    dados.append('marca[descricao]', this.marca.descricao);    

    this.marcaService.salvar(dados).subscribe(() => {
      this.notificacaoService.sucesso('Marca salva com sucesso!!!');
      this.carregandoService.esconde('salvaMarca');
      this.dialogRef.close(this.marca);

    }, (erro) => {
      this.carregandoService.esconde('salvaMarca');
      this.notificacaoService.erro(erro);
    });
  }

  ngOnDestroy(): void {

  }

  fechar() {
    this.dialogRef.close();
  }

  onFileChanged(event) {
    this.selectedFile = event.target.files[0];
  }

  baixarArquivo() {

    this.carregandoService.mostra('baixarArquivo');
    this.arquivoService.baixarArquivo(this.marca.idMarca, TipoArquivo.Marca).subscribe(arq => {
      this.utilitarioService.saveBlob(arq, this.nomeArquivoBanco);
      this.carregandoService.esconde('baixarArquivo');
    }, (erro) => {
      this.carregandoService.esconde('baixarArquivo');
      this.notificacaoService.erro(erro);
    });

  }

  excluirArquivo() {
    this.selectedFile = undefined;
    this.marca.imagem = '';
  }
}
